import React from 'react';
import PropTypes from 'prop-types';
import ChatMessage from '../ChatMessage';

const ChatMessageList = ({ messages = [], onScore, placeholder }) => {
  if (!messages || messages.length === 0) {
    return placeholder ? <div className="chat-empty-state">{placeholder}</div> : null;
  }

  return (
    <div className="chat-message-list" role="list">
      {messages.map((message, index) => (
        <ChatMessage key={message.id ?? index} message={message} onScore={onScore} />
      ))}
    </div>
  );
};

ChatMessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
  onScore: PropTypes.func, // Callback for when user scores a message
  placeholder: PropTypes.node // Content to show when no messages
};

export default React.memo(ChatMessageList);
